const NoDisponible = () => {
  return (
    <div className="w-full h-[calc(80vh-150pt)] grid content-center justify-center">
      <img src="./img/mantenimiento.png" alt="Formulario" width={700} />
      <h3 className="font-bold text-center text-slate-500 text-lg">
        Estamos trabajando para darle un mejor servicio.
      </h3>
    </div>
  );
};

export default NoDisponible;
